<template>
    <div class="at-chatfloatholder">
        <div id="signin" class="at-floatchat at-signin">
            <div class="at-floatchat_content">
                <div class="at-floatchat_title">
                    <h2>{{TRANS.signin_box_hdr_txt}}</h2>
                    <div class="at-floatchat_title-right">
                        <a href="javascript:void(0);" class="at-removechat" @click.prevent="$emit('closeWidget')"><i class="guppy-x"></i></a>
                    </div>
                </div>
                <form class="at-themeform at-floatsignin">
                    <fieldset>
                        <div class="at-form-group-wrap">
                            <div class="at-form-group">
                                <label class="at-formtitle at-important">{{TRANS.email}}</label>
                                <input type="text" required @keyup.enter="signIn()" v-model="data.username" class="at-form-control" :placeholder="TRANS.email">
                            </div>
                            <div class="at-form-group">
                                <label class="at-formtitle at-important">{{TRANS.password}}</label>
                                <input type="password" @keyup.enter="signIn()" v-model="data.userpassword" required class="at-form-control" :placeholder="TRANS.password">
                            </div>
                            <div class="at-form-group">
                                <a href="javascript:void(0);" :class="{'at-disable-btn' : isloading }" @click.prevent="signIn()" class="at-btn">{{TRANS.start_chat_text}}</a>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : 'GuppySignInWidgetBox',
    data(){
        return {
            data : { 
                userpassword : '',
                username : ''
            },
            isloading : false
        }
    },
    methods:{
        signIn(){
            if(!this.isloading){
                this.isloading = true;
                if(this.data.username && this.data.userpassword ){
                    this.axios.post('user-login', this.data).then( response =>{
                        this.isloading = false;
                        if(response.data.type == 'success' ){
                            window.location.reload();
                        } else {
                            this.alertBox('error', this.TRANS.error_title, response.data.message );
                        }
                    }).catch( errors => {
                        this.isloading = false;
                        this.errors = errors;
                        this.alertBox('error', this.TRANS.error_title, this.TRANS.empty_input_err_txt );
                    })
                } else {
                    this.isloading = false;
                    this.alertBox('error', this.TRANS.error_title, this.TRANS.empty_input_err_txt );
                }
            }
        }
    },

}
</script>

<style>

</style>